import { render, staticRenderFns } from "./PlateformCentral.vue?vue&type=template&id=77eec63c&"
import script from "./PlateformCentral.vue?vue&type=script&lang=ts&"
export * from "./PlateformCentral.vue?vue&type=script&lang=ts&"
import style0 from "./PlateformCentral.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports